import React, { useState } from "react";
import { useFilters } from "../dashboard/FilterContext";
import { useDetailsFilters } from "../RouteDetails/DetailsFilterContext";
import { EventTypeOptions } from "../settings/SettingsPage";
import { MultiSelect } from "./common/MultiSelect";

interface EventTypeFilter {
    id: string;
    label: string;
}

export const EventTypeFilter: React.FC<{ details?: boolean }> = ({ details = false }) => {

    const test: EventTypeFilter[] = EventTypeOptions.map((item) => {
        return {
            id: item,
            label: item,
        };
    });


    const [eventType, setEventTypes] = useState<EventTypeFilter[]>(test);

    const { filters: dashboardFilters, setFilters: dashboardSetFilters } = useFilters();
    const { filters, setFilters: detailSetFilters } = useDetailsFilters();

    return (
        <div className="px-4">
            <MultiSelect
                options={eventType ?? []}
                title="Events"
                onSelect={(selectedIds: string[]) => {
                    if (details) {
                        detailSetFilters((prevFilters) => ({
                            ...prevFilters,
                            eventTypes: selectedIds,
                        }));
                        return;
                    }
                    dashboardSetFilters((prevFilters) => ({
                        ...prevFilters,
                        eventTypes: selectedIds,
                    }));
                }} />
        </div>
    );
};